<template>
  <button @click.stop="handleRoundBtnClick"><slot></slot></button>
</template>

<script>

export default {
  name: 'RoundButton',

  props: {
    isSub: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleRoundBtnClick() {
      this.$emit('handleRoundBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  background-color: $white;
  color: $headerfoterColor;
  font-size: 16px;
  font-weight: 700;
  border-radius: 50px;
  padding: 8px 20px;
  transition: .4s;
  border: 4px solid $headerfoterColor;
  &:hover {
    opacity: .4;
  }
}
@media screen and (max-width: $tabletWidth) {
  button {
    &:hover {
      opacity: 1;
    }
  }
}
</style>
